// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2al2y","notAuthorizedBadge":"styles_notAuthorizedBadge__ShOrw"};